/* eslint-disable react/no-unused-prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import { injectIntl, intlShape } from 'react-intl';
import { decorateWith, withName } from 'helpers/decorator';
import { isBlank, isObject } from 'helpers/verify';
import { LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';

const internationalizeContent = (intl, content) => (isObject(content) ? intl.formatMessage(content) : content);

const renderLink = (rel, href) => !isBlank(href) && <link rel={rel} href={href} />;
const renderMeta = (metaName, content) => !isBlank(content) && <meta name={metaName} content={content} />;
const renderOpenGraph = (metaName, content) => !isBlank(content) && <meta property={metaName} content={content} />;
const renderTitle = content => !isBlank(content) && <title>{content}</title>;

export const MetadataUnwrapped = ({
  canonicalUrl,
  description,
  intl,
  ogDescription,
  ogImage,
  ogTitle,
  ogUrl,
  shouldIndex = true,
  title,
} = {}) => {
  const internationalizer = internationalizeContent.bind(null, intl);
  return (
    <Helmet>
      {renderTitle(internationalizer(title))}
      {renderMeta('description', internationalizer(description))}
      {renderOpenGraph('og:title', internationalizer(ogTitle || title))}
      {renderOpenGraph('og:description', internationalizer(ogDescription || description))}
      {renderOpenGraph('og:image', ogImage)}
      {renderOpenGraph('og:url', ogUrl)}
      {renderMeta('robots', shouldIndex ? 'index' : 'noindex')}
      {renderLink('canonical', canonicalUrl)}
    </Helmet>
  );
};

MetadataUnwrapped.propTypes = {
  canonicalUrl: PropTypes.string,
  description: LocalizableMessageShape,
  intl: intlShape,
  ogDescription: LocalizableMessageShape,
  ogImage: PropTypes.string,
  ogTitle: LocalizableMessageShape,
  ogUrl: PropTypes.string,
  shouldIndex: PropTypes.bool,
  title: LocalizableMessageShape,
};

export const Metadata = decorateWith(injectIntl, withName('Metadata'))(MetadataUnwrapped);
